
let obj = {
  haoyin:['hy-test.taototo','hy.pintoto'],
  youyv:['yy-test.taototo','yy.pintoto'],
  st:['movie-test.taototo','movie.pintoto'],
  ceshi:['localhost:8080/']
}

// 判断是哪个代理
export function findKeyByUrl(partialUrl) {
  if(!partialUrl) return null
  let path = partialUrl.split('#')[0]
  console.log(path,'域名')
  // 遍历对象的键值对
  for (const key in obj) {
    // 使用 some 方法检查数组中的某个字符串是否包含 partialUrl
    if (obj[key].some(item => path.includes(item))) {
      return key; // 找到后返回对应的 key
    }
  }
  return null; // 如果没有找到匹配的 key，则返回 null
}



// WEBPACK FOOTER //
// ./src/utils/platform.js